import * as Yup from 'yup';

import { ITEM_NUMBER_LENGTH, isValidItemNumber } from '../../utils/item-number.utils';

const VALIDATION_MESSAGES = {
   itemNos: `All item numbers must be exactly ${ITEM_NUMBER_LENGTH} digits`,
} as const;

const validateItemNumbers = (value: unknown): boolean => {
   if (!value || (Array.isArray(value) && value.length === 0)) {
      return true;
   }
   if (!Array.isArray(value)) {
      return false;
   }
   return value.every((val) => typeof val === 'string' && isValidItemNumber(val));
};

const nullableString = Yup.string().nullable();
const nullableBoolean = Yup.boolean().nullable();
const nullableStringArray = Yup.array().of(Yup.string()).nullable();

export const filterValidationSchema = Yup.object().shape({
   itemNos: Yup.array().nullable().test('isValidItemNumberArray', VALIDATION_MESSAGES.itemNos, validateItemNumbers),

   buCodePru: nullableString,
   buCodePdu: nullableString,
   itemName: nullableString,
   itemState: nullableString,
   part: nullableString,
   materialGrade: nullableString,
   partDetail: nullableString,
   comment: nullableString,
   updatedBy: nullableString,

   locked: nullableBoolean,
   unlocked: nullableBoolean,
   dwpDeviates: nullableBoolean,
   isBase: nullableBoolean,
   excludeConnected: nullableBoolean,
   missingGradeId: nullableBoolean,
   outgoingGradeIds: nullableBoolean,

   hfbs: nullableStringArray,
   pas: nullableStringArray,
   familyName: nullableStringArray,
   ssd: nullableStringArray,
   eds: nullableStringArray,
    progressState: nullableStringArray,
   piaImportStatus: nullableStringArray,
});
